<script>
    import {APP_PATH, APP_VERSION} from "./lib/constants";
    import Route, {router} from "./lib/Router/Router.svelte";
    import {cookie} from "./lib/cookie";
    import R from "./lib/requests";
    import app from './stores/app';
    import user from "./stores/user";
    import Login from "./components/pages/Login.svelte";
    import AppHeader from "./components/AppHeader.svelte";
    import AppMenu from "./components/AppMenu.svelte";
    import Alert from "./components/Alert.svelte";
    import Notifier from './components/Notifier.svelte';
    import PageLoader from "./components/PageLoader.svelte";
    import PopupLoader from "./components/PopupLoader.svelte";
    import Analyses from "./settings/analyses/Analyses.svelte";
    import AnalysisGroups from "./settings/analysis_groups/AnalysisGroups.svelte";
    import Users from "./users/Users.svelte";
    import Clients from "./clients/Clients.svelte";
    import OrderEdit from "./orders/OrderEdit.svelte";
    import Orders from "./orders/Orders.svelte";
    import Samples from "./samples/Samples.svelte";
    import SampleEdit from "./samples/SampleEdit.svelte";
    import Settings from "./settings/Settings.svelte";
    import StatisticsPdf from "./statistics/StatisticsPdf.svelte";
    import StatisticsExcel from "./statistics/StatisticsExcel.svelte";
    import CloudAnalyses from "./statistics/CloudAnalyses.svelte";

    let appInitialized = false;

    const initUser = async () => {
        let coo = cookie.get('analytikon') || null;
        if (coo) {
            $user.token = coo;
        }
    }

    const appInitialize = () => {
        const onSuccess = result => {
            $user.id = result.user.id;
            $user.name = result.user.name;
            $user.email = result.user.email;
            $user.role = ~~result.user.role;

            $app.sample_types = result.settings.sample_types;
            $app.sample_packages = result.settings.sample_packages;
            $app.sampling_from = result.settings.sampling_from;
            $app.sampling_method = result.settings.sampling_method;
            $app.cloud_url = result.cloud_url;

            if (APP_VERSION !== result.app_version) {
                alert("Η έκδοση της εφαρμογής που χρησιμοποιείται είναι πεπερασμένη!\nΚαθαρίστε την προσωρινή μνήμη του browser σας και ανανεώστε αυτή την σελίδα για να χρησιμοποιήσετε την πιο πρόσφατη έκδοση της εφαρμογής.");
            }

            appInitialized = true;
        }

        const onFailure = err => {
        };

        if ($user.token != null && $user.token !== '') {
            R.handle(R.app.initialize, [], onSuccess, onFailure);
        }

    }

    window.addEventListener('resize', function (event) {
        app.windowResize();
    });
    app.windowResize();

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && $app.escapeEventHandlers.length) {
            $app.escapeEventHandlers[$app.escapeEventHandlers.length - 1]();
        }
    });

    initUser();

    $: {
        if ($user.token != null && !appInitialized) {
            appInitialize();
        }

        if (appInitialized) {
            if (router.url === "/") {
                router.go(`/${APP_PATH}`)();
            }
        }
    }
</script>


{#if !$user.token}
    <Login/>
{:else if appInitialized}
    <PageLoader/>
    <PopupLoader/>
    <AppHeader/>
    <AppMenu/>
    <main>
        <div class="app-main-content">
            <div class="container-fluid">
                <Route match="/">
                    <Route match="{APP_PATH}">
                        <Route match="clients">
                            <Clients/>
                        </Route>
                        <Route match="new-order" let:router>
                            <OrderEdit orderId="0"/>
                        </Route>
                        <Route match="order" let:router>
                            <OrderEdit orderId="{ router.id }"/>
                        </Route>
                        <Route match="orders">
                            <Orders/>
                        </Route>
                        <Route match="sample" let:router>
                            <SampleEdit sampleId="{ router.id }"/>
                        </Route>
                        <Route match="samples">
                            <Samples/>
                        </Route>
                        <Route match="stats-pdf">
                            <StatisticsPdf/>
                        </Route>
                        <Route match="stats-excel">
                            <StatisticsExcel/>
                        </Route>
                        <Route match="cloud-analyses">
                            <CloudAnalyses/>
                        </Route>
                        <Route match="analyses">
                            <Analyses/>
                        </Route>
                        <Route match="analysis-groups">
                            <AnalysisGroups/>
                        </Route>
                        <Route match="users" guard="{ user.isAdmin }">
                            <Users/>
                        </Route>
                        <Route match="settings">
                            <Settings/>
                        </Route>
                    </Route>
                </Route>
            </div>
        </div>
    </main>
{/if}

<Alert/>
<Notifier/>

<style>
    main {
        width: 100%;
        padding-top: var(--header-height);
    }

    @media (max-width: 999px) {
        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1000px) and (max-width: 1024px) {
        main {
            padding-left: 50px;
        }

        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1025px) {
        main {
            padding-left: var(--aside-width);
        }

        main .app-main-content {
            padding: 30px 10px 20px 10px;
        }
    }
</style>